import React, { useState } from 'react';
import './CopyButton.css';

/* Small copy-to-clipboard button. Shows a ✓ for ~1.5s after copying.
   Stops click propagation so it works inside clickable cards/rows. */
const CopyButton = ({ text, label = 'Copy' }) => {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    if (e) e.stopPropagation();
    const value = String(text || '');
    if (!value) return;
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 1500); };
    try {
      await navigator.clipboard.writeText(value);
      done();
    } catch (_) {
      // Fallback for non-secure contexts / older browsers.
      try {
        const ta = document.createElement('textarea');
        ta.value = value; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (__) { /* clipboard unavailable */ }
    }
  };

  return (
    <button
      type="button"
      className={`copy-btn ${copied ? 'copied' : ''}`}
      onClick={copy}
      title={copied ? 'Copied!' : label}
      aria-label={label}
    >
      {copied ? '✓' : '⧉'}
    </button>
  );
};

export default CopyButton;
